import styled from 'styled-components';

export const StyledContainer = styled.div`
  margin: 0 32px;
`;

export const PageContainer = styled.div`
  display: flex;

  aside {
    padding: 74px 21px 0px 40px;
  }
`;
